var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0645 16.1201V22.4286C21.0645 22.9866 21.0025 23.5136 20.863 23.9941C20.2895 26.2726 18.3985 27.6986 15.7945 27.6986H11.5785L6.8975 30.8141C6.2 31.2946 5.27 30.7831 5.27 29.9461V27.6986C3.689 27.6986 2.3715 27.1716 1.457 26.2571C0.527 25.3271 0 24.0096 0 22.4286V16.1201C0 13.1751 1.829 11.1446 4.65 10.8811C4.8515 10.8656 5.053 10.8501 5.27 10.8501H15.7945C18.9565 10.8501 21.0645 12.9581 21.0645 16.1201Z",
    fill: "#3A3A3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4129 21.08C26.3814 21.08 28.0399 20.429 29.1869 19.2665C30.3494 18.1195 31.0004 16.461 31.0004 14.4925V6.5875C31.0004 2.945 28.0554 0 24.4129 0H11.2379C7.59539 0 4.65039 2.945 4.65039 6.5875V7.75C4.65039 8.184 4.99139 8.525 5.42539 8.525H15.7949C19.9954 8.525 23.3899 11.9195 23.3899 16.12V20.305C23.3899 20.739 23.7309 21.08 24.1649 21.08H24.4129Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.484484cdd58b2d20b45941873b27ccbd.svg";
export { ForwardRef as ReactComponent };